export default __webpack_public_path__ + "images/fd1a5d7670e3a7fa5c520acc4ac0567d.png";